<template>
    <FormModel
        :action="submit" :label-col="{span: 5}" :model="resume"
        :rules="ConstValue.resumeRules" :wrapper-col="{span: 19}" style="width: 480px">
        <a-form-model-item label="入行年份" prop="since">
            <BaseSelect :options="ConstValue.sinceOpts()" style="width: 50%;" v-model="resume.since"/>
        </a-form-model-item>
        <a-form-model-item label="现居住地" prop="address[0]">
            <AreaPicker placeholder="请选择您当前居住地" v-model="resume.address"/>
        </a-form-model-item>
        <a-form-model-item label="相机型号" prop="camera">
            <div :key="index" style="margin-bottom:6px;" v-for="(camera, index) in resume.camera">
                <a-input placeholder="请完善您的相机品牌型号" v-model="resume.camera[index]">
                    <a-icon slot="prefix" type="camera"/>
                    <a-tooltip slot="suffix" v-if="resume.camera.length > 1">
                        <a-icon @click="delCamera(index)" type="close-circle"/>
                    </a-tooltip>
                </a-input>
            </div>
            <a-button @click="addCamera" block ghost icon="plus-circle" type="primary">添加相机</a-button>
        </a-form-model-item>
        <a-form-model-item label="镜头型号" prop="lenses">
            <div :key="index" style="margin-bottom:6px;" v-for="(lenses, index) in resume.lenses">
                <a-input placeholder="请完善您的镜头品牌型号" v-model="resume.lenses[index]">
                    <a-icon slot="prefix" type="crown"/>
                    <a-tooltip slot="suffix" v-if="resume.lenses.length > 1">
                        <a-icon @click="delLenses(index)" type="close-circle"/>
                    </a-tooltip>
                </a-input>
            </div>
            <a-button @click="addLenses" block ghost icon="plus-circle" type="primary">添加镜头</a-button>
        </a-form-model-item>
        <a-form-model-item label="经验简介">
            <a-input placeholder="简要描述您的拍摄经验" rows="5" type="textarea" v-model="resume.comment"/>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import api from "../../../utils/api";
    import func from "../../../utils/func";
    import FormModel from "../../../comps/FormModel";
    import ConstValue from "./ConstValue";
    import AreaPicker from "../../../comps/AreaPicker";
    import BaseSelect from "../../../comps/BaseSelect";

    export default {
        name: "Resume",
        props: {
            user: Object,
        },
        components: {BaseSelect, AreaPicker, FormModel},
        data() {
            return {
                resume: {
                    since: 2020,
                    address: [0, ""],
                    camera: [""],
                    lenses: [""],
                    comment: "",
                },
                ConstValue: ConstValue
            };
        },
        mounted() {
            if (this.user.resume !== null) {
                this.resume = func.copyObject(this.user.resume);
            }
        },
        methods: {
            submit() {
                return api.v1.user.setResume(this.resume)
                    .then(() => this.user.resume = this.resume);
            },
            addCamera() {
                this.resume.camera.push("");
            },
            delCamera(index) {
                this.resume.camera.splice(index, 1);
            },
            addLenses() {
                this.resume.lenses.push("");
            },
            delLenses(index) {
                this.resume.lenses.splice(index, 1);
            }
        }
    }
</script>
